import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const filter = {
	SkladpneuOzn: null as number | null,
	Text: null as string | null,
	Popis: null as string | null,
	VyrazenPrp: null as boolean | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladpneuOzn: [],
	},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
